import './ads.scss';
import { useEffect, useState, useRef } from 'react';

const SinglePageBanner = () => {
  const [showFallback, setShowFallback] = useState(false);
  const bannerRef = useRef(null);

  useEffect(() => {
    // Настройка зоны Adsterra
    window.atOptions = {
      key: '9947d2cf59b577e7e06b884b2e6cc9c7', 
      format: 'iframe',
      height: 250,
      width: 300,
      params: {}
    };

    const container = bannerRef.current;
    if (!container) return;

    container.innerHTML = '';

    const adScript = document.createElement('script');
    adScript.src = '//www.highperformanceformat.com/9947d2cf59b577e7e06b884b2e6cc9c7/invoke.js'; 
    adScript.type = 'text/javascript';
    adScript.async = true;

    container.appendChild(adScript);

    const fallbackTimer = setTimeout(() => {
      const iframe = container.querySelector('iframe');
      if (!iframe || iframe.clientHeight === 0) {
        setShowFallback(true);
      }
    }, 3000);

    return () => clearTimeout(fallbackTimer);
  }, []);

  return (
    <div className="bannerOne">
      {showFallback ? (
        <a
          href="https://www.banggood.com/marketing-Electric-Transport-Mega-Sale-In-2025/tid-78768.html?utmid=24568%3Futm_design%3D132&bid=57569&utm_design=132&p=PV201177962054202506&custlinkid=4751439"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://img.staticbg.com/deals/affiliate_member_banner_new/202506/20/20250620021618_334.jpg"
            alt="Banggood Electric Transport Mega Sale 2025"
            style={{ width: '300px', height: '250px', border: '1px solid #ccc' }}
          />
        </a>
      ) : (
        <div ref={bannerRef} />
      )}
    </div>
  );
};

export default SinglePageBanner;
